import { render } from "./FeMathsReport.vue?vue&type=template&id=c250f560"
import script from "./FeMathsReport.vue?vue&type=script&lang=js"
export * from "./FeMathsReport.vue?vue&type=script&lang=js"
script.render = render

export default script